<div class="pag-container">

  <app-kv-breadcrumb [arrayBreadcrumbs]="breadcrumbs"></app-kv-breadcrumb>

  <form [formGroup]="dateRangeForm">
    <div class="ui-g-12">

      <div class="ui-g-6" style="margin-top: 20px;">
        <div class="ui-g-8 d-flex align-items-center">
          <span class="title"></span>
        </div>
        <div class="ui-g-4 d-flex align-items-center">
          <span class="title-span">{{ 'common.selectInterval' | translate }}</span>
        </div>
      </div>

      <div class="ui-g-3">
        <span class="date-range">{{ 'common.from' | translate }}</span>
        <br>
        <app-kv-calendar #dateStartField [inputName]="'startDate'" [formData]="dateRangeForm" [startDateSelector]="true"
          [endDateInputName]="'endDate'" [endDateCalendar]="dateEndField"></app-kv-calendar>
      </div>

      <div class="ui-g-3">
        <span class="date-range">{{ 'common.to' | translate }}</span>
        <br>
        <app-kv-calendar #dateEndField [inputName]="'endDate'" [formData]="dateRangeForm" [endDateSelector]="true"
          [startDateInputName]="'startDate'" [startDateCalendar]="dateStartField"></app-kv-calendar>
      </div>
    </div>


  </form>

  <div class="ui-g-12">
    <app-campaign-3-kontable #rulesAppliedListTable id="rulesAppliedListTable" [columns]="[
        {field: 'id', title: '#', filterType: noFilter, sortable: false},
        {field: 'tsInsert', title: 'audit.rulesAppliedDate', filterType: noFilter, bodyTemplate: dateTimeTemplate},
        {field: 'auditEventId', title: 'audit.eventId', bodyTemplate: eventIDTemplate},
        {field: 'auditRuleId', title: 'audit.ruleId', bodyTemplate: ruleIDTemplate},
        {field: 'auditRuleDescription', title: 'audit.rulesAppliedDescription', bodyTemplate: ruleDescriptionTemplate},
        {field: 'flgDeploy', title: 'audit.ruleAppliedStatus', bodyTemplate: stateFilter, filterType: selectFilter, filterOptions: { values: statusList }}
      ]" [service]="rulesAppliedService" [paginationType]="paginationType" [showRecoverButton]="false"
      [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showDetailsButton]="false"
      [showEditButton]="false" [showGlobalFilter]="true" [filterStartDate]="dateRangeForm.get('startDate').value"
      [filterEndDate]="dateRangeForm.get('endDate').value" (onClearFilters)="clearDateFilters()"
      [filterBySingleColumn]="false" [expandTable]="false" [additionalRowCommands]="actions"
      [fetchActionListAsap]="true">

      <ng-template #dateTimeTemplate let-row>
        <span>{{ row.ts_ins | date:'dd/MM/yyyy' }}</span>
      </ng-template>

      <ng-template #eventIDTemplate let-row>
        <span>{{ row.audit_event_id.id }}</span>
      </ng-template>

      <ng-template #ruleIDTemplate let-row>
        <span>{{ row.audit_rule_id.id }}</span>
      </ng-template>

      <ng-template #ruleDescriptionTemplate let-row>
        <span>{{ row.audit_rule_id.description }}</span>
      </ng-template>

      <ng-template #stateFilter data-testid="stateFilter" let-row>
        <span *ngIf="row.flg_dpl === '0'">
          {{'audit.eventElStarted' | translate}}
        </span>
        <span *ngIf="row.flg_dpl === '1'">
          {{'audit.eventElOk' | translate}}
        </span>
        <span *ngIf="row.flg_dpl === '9'">
          {{'audit.eventElKo' | translate}}
        </span>
      </ng-template>

      <ng-template #actions let-row>
        <div class="detail-btn-container">
          <button class="btn-details" (click)="onOpenInfoActionDetEvent(row.audit_event_id)">
            <i class="pi pi-calendar icon-size"></i>
          </button>
          <button class="btn-details" (click)="onOpenInfoActionDetRule(row.audit_rule_id)">
            <i class="pi pi-eye icon-size"></i>
          </button>
        </div>
      </ng-template>

    </app-campaign-3-kontable>
  </div>
  <div *ngIf="showPopupInfoInsideTableDetEvent">
    <p-dialog header="{{ 'audit.eventDetail' | translate }}" [(visible)]="showPopupInfoInsideTableDetEvent"
      [modal]="true" [style]="{width: '60vw', height: '90vh'}" [draggable]="false" [resizable]="false"
      (onHide)="onClosePopupInfoDetailEvent()">
      <div style="max-height: 75vh; overflow: auto;">
        <pre>{{selectedEventContent | json}}</pre>
      </div>
    </p-dialog>
  </div>

  <div *ngIf="showPopupInfoInsideTableDetRule">
    <p-dialog header="{{ 'audit.ruleDetail' | translate }}" [(visible)]="showPopupInfoInsideTableDetRule" 
      [modal]="true"
      [style]="{width: '60vw', height: '90vh'}" [draggable]="false" [resizable]="false"
      (onHide)="onClosePopupInfoDetailRule()">
      <div style="max-height: 75vh; overflow: auto;">
        <pre>{{selectedRuleContent | json}}</pre>
      </div>
    </p-dialog>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/audit/rulesapplied/rulesapplied.component.html